<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer001">
<p class="_about" id="_idParaDest-1"><span epub:type="pagebreak" id="pageiv" title="iv"></span></p>
<p class="drop" lang="en-GB" xml:lang="en-GB"><span class="drop-cap"> A</span>nna Franklin is a third-degree witch and high priestess of    the Hearth of Arianrhod, and she has been a practicing Pagan for more than forty years. She is the author of thirty books and the creator of the <span class="ital">Sacred Circle Tarot</span>, <span class="ital">Fairy Ring Oracle</span>, and the <span class="ital">Pagan Ways Tarot</span> (Schiffer, 2015). Her books have been translated into nine languages. </p>
<p class="tx" lang="en-GB" xml:lang="en-GB"><span lang="en-US" xml:lang="en-US">Anna has contributed hundreds of articles to Pagan magazines and has appeared on radio and TV. She lives and works in a village in the English Midlands, where she grows her own herbs, fruit, and vegetables, and generally lives the Pagan life. Visit her online at </span><span class="link" lang="en-US" xml:lang="en-US">www.AnnaFranklin.co.uk</span><span lang="en-US" xml:lang="en-US">.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About.vue?22385dde